import React, { useEffect, useState } from "react";
import { Card, Col, Form, FormControl, ListGroup, Row } from "react-bootstrap";
import { AiOutlineCheck } from "react-icons/ai";
import { SlEnergy } from 'react-icons/sl';
import { TbFlame } from 'react-icons/tb';
import { MdOutlineOilBarrel, MdOutlineSolarPower } from 'react-icons/md';
import RangeSlider from 'react-range-slider-input';
import "react-range-slider-input/dist/style.css";
import ElvListItem from "./ElvListItem";
import EnergoPagination from "../shared/EnergoPagination";
import { FaSquareXmark } from "react-icons/fa6";
import EnergoTooltip from "../shared/EnergoTooltip";

/**
 * ElvTable
 * 
 * Displays table with Energielieferverträge passed from ElvPage as prop
 * 
 * used in /pages/hw/ElvPage
 * 
 * @param {Energielieferverträge} props all Energielieferverträge from this building
 * @returns html table
 */
const ElvTable = ({ elvs, anlagen, selectedAnlage, setSelectedAnlage }) => {

    const [clearFilterHidden, setClearFilterHidden] = useState(true); // state for showing/hidding active filters

    const [maxItemsInPagination, setMaxItemsInPagination] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentView, setCurrentView] = useState([]);

    const [selectedElvs, setSelectedElvs] = useState([]); // selected or filtered Elvs
    const [energy, setEnergy] = useState([]); // state for EnergieForm filter
    const [avaibleYears, setAvaibleYears] = useState([]) // state for avaible years from Elvs

    const [selectedName, setSelectedName] = useState(""); // state for search field
    const [selectedEnergy, setSelectedEnergy] = useState(""); // state for selected EnergieForm
    const [selectedYear, setSelectedYear] = useState(0); // state for selected year
    const [monthRange, setMonthRange] = useState([1, 12]); // state for selected month range belbeg
    const [leerstand, setLeerstand] = useState(false);
    const [delivery, setDelivery] = useState(true);

    const [searchInFocus, setSearchInFocus] = useState(false);




    // Effect when elvs get data
    useEffect(() => {
        if (elvs && elvs.length > 0) {
            //setSelectedElvs(elvs);
            checkActiveFilters();
            setCurrentPage(1);

            var year_list = [];
            elvs?.map(elv => {
                if (elv.x_belbeg !== 'False') {
                    var y = elv.x_belbeg.slice(0, 4);
                    var index = year_list.findIndex(x => x === Number(y));
                    if (index === -1 && y !== NaN) return year_list.push(Number(y));
                }
            });

            var energy_list = [];
            anlagen?.map(a => {
                var en = a.x_studio_field_3eKe0;
                var index = energy_list.findIndex(x => x === en);
                if (index === -1 && en !== "") energy_list.push(en);
            });

            if (anlagen.length === 0) energy_list = ['Strom', 'Gas', 'Strom-Einspeisung'];
            setAvaibleYears(year_list);
            setEnergy(energy_list);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elvs]);


    useEffect(() => {
        if (selectedElvs.length > maxItemsInPagination) {
            var start = (currentPage - 1) * maxItemsInPagination;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(selectedElvs.slice(start, end));
        } else {
            setCurrentView(selectedElvs);
        }
    }, [maxItemsInPagination])


    useEffect(() => {
        if (selectedElvs.length > maxItemsInPagination) {
            var start = (currentPage - 1) * maxItemsInPagination;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(selectedElvs.slice(start, end));
        } else {
            setCurrentView(selectedElvs);
        }
    }, [currentPage, selectedElvs])

    // Effect when Anlage is clicked/state of selectedAnlageId has changed
    useEffect(() => {
        checkActiveFilters();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAnlage])


    // Effect when search field changes
    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedName]);


    // Effect when EnergieForm changes
    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEnergy]);


    // Effect when Year in filter changes
    useEffect(() => {
        checkActiveFilters();
    }, [selectedYear])


    // Effect when month range belbeg changes
    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthRange]);

    // Effect when leerstand changes
    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leerstand])

    // Effect when delivery changes
    useEffect(() => {
        checkActiveFilters();
        // esling-disable-next-line react-hooks/exhaustive-deps
    }, [delivery])



    // Function to display Range as string
    const getDateRange = () => {
        let date1 = new Date();
        let date2 = new Date();
        date1.setMonth(monthRange[0] - 1);
        date2.setMonth(monthRange[1] - 1);
        let from = date1.toLocaleDateString('DE-de', { month: 'long' });
        let till = date2.toLocaleDateString('DE-de', { month: 'long' })
        return `Belieferungsbeginn ${from} - ${till}`;
    }


    // Function to set all filters to default value
    const clearAllFilters = () => {
        if (selectedAnlage === undefined || selectedAnlage.length === 0) {
            setSelectedElvs(elvs);
        } else {
            setSelectedElvs(elvs.filter(e => e.x_anlage_id[0] === selectedAnlage[0]));
        }
        setSelectedName("");
        setSelectedEnergy("");
        setSelectedYear(0);
        setClearFilterHidden(true);
        setMonthRange([0, 12]);
        setLeerstand(false);
        setDelivery(false);
    }


    // Function to check which filters are active and apply them
    const checkActiveFilters = () => {
        var count = 0;
        var initialElvs = [];
        var filtered = [];

        if (selectedAnlage !== undefined && selectedAnlage.length > 0) {
            initialElvs = selectedElvs;
        } else {
            initialElvs = elvs;
        }

        if (selectedAnlage === undefined || selectedAnlage.length === 0) {
            initialElvs = elvs;
        } else {
            initialElvs = elvs.filter(x => x.x_anlage_id[0] === selectedAnlage[0]);
        }

        if (leerstand === true) {
            if (initialElvs.length > 0) {
                filtered = initialElvs.filter(x => x.x_is_leerstand === true);
                initialElvs = filtered;
                count++;
            }
        }

        if (delivery === true) {
            if (initialElvs.length > 0) {
                var currentDate = new Date();
                var currentYear = currentDate.getFullYear();
                var nextYear = new Date(currentYear + 1, 0, 1);

                filtered = initialElvs.filter(x => x.x_datum_vertragsende !== undefined && new Date(x.x_datum_vertragsende) > currentDate && new Date(x.x_datum_vertragsende) < nextYear);
                initialElvs = filtered;
                count++;
            }

        }

        if (selectedEnergy !== "") {
            filtered = initialElvs.filter(x => x.x_anlage_id[1].split('_')[1].toLowerCase().includes(selectedEnergy.toLowerCase()) === true);
            initialElvs = filtered;
            count++;
        }

        if (selectedYear !== 0) {
            filtered = initialElvs.filter(x => Number(x.x_belbeg.slice(0, 4)) === selectedYear);
            initialElvs = filtered;
            count++;
        }

        if (monthRange[0] > 1 || monthRange[1] < 12) {
            filtered = initialElvs.filter(x => x.x_belbeg !== '' && x.x_belbeg !== 'False' && parseInt(x.x_belbeg.split("-")[1]) >= monthRange[0] && parseInt(x.x_belbeg.split('-')[1]) <= monthRange[1]);
            initialElvs = filtered;
            count++;
        }

        if (selectedName !== "") {
            filtered = initialElvs.filter(x =>
                x.x_anlagennummer_lieferant.toLowerCase().includes(selectedName.toLowerCase()) ||
                x.x_kunde_id[1].toLowerCase().includes(selectedName.toLowerCase()));

            var filtered_addresses = anlagen.filter(a =>
                a.x_adresse_kompakt.toLowerCase().includes(selectedName.toLowerCase())
            );

            var address_elvs = [];
            for (var i = 0; i < filtered_addresses.length; i++) {
                var tempElv = initialElvs.filter(e => e.x_anlage_id[0] === filtered_addresses[i].id);
                if (tempElv.length > 0) {
                    address_elvs = address_elvs.concat(tempElv);
                }
            } 

            address_elvs.forEach(e => {
                if (!filtered.includes(e)) {
                    filtered.push(e);
                }
            });
            initialElvs = filtered;
            count++;
        }

        if (count > 0) { setClearFilterHidden(false); }
        else setClearFilterHidden(true);
        setSelectedElvs(initialElvs);
    }



    // GUI
    return (
        <>
            <Row className="mt-5 text-start">
                <Col xs="12" md="4" xl="3">
                    {!clearFilterHidden ?
                        <a
                            onClick={e => { e.preventDefault(); clearAllFilters() }}
                            href="/flters/reset"
                            className="clear-filters"
                        >
                            <FaSquareXmark size={30} />
                            &nbsp; Aktuelle Filter zurücksetzen
                        </a>
                        :
                        null
                    }
                </Col>
                <Col xs="12" md="4" xl="3">
                    {selectedAnlage && selectedAnlage.length > 0 ? (
                        <a
                            onClick={e => { e.preventDefault(); setSelectedAnlage([]) }}
                            href="/filters/anlage/clear"
                            className="clear-filters"
                        >
                            <FaSquareXmark size={30} />
                            &nbsp; Ausgewählte Anlage {selectedAnlage[1]}
                        </a>
                    ) : null}
                </Col>
                <Col xs="12" md="4" xl="6" className="text-end">
                    <div className="d-inline-block">
                        <Form.Select defaultChecked={maxItemsInPagination} onChange={e => setMaxItemsInPagination(e.target.value)} >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </Form.Select>
                    </div>
                    <small style={{marginLeft: "5px"}}>pro Seite</small>

                </Col>
            </Row>
            <Card style={{ borderRadius: "15px", borderBottom: "3px solid #a2c13f", borderLeft: "3px solid #a2c13f" }} className="mt-3 shadow-lg">
                <Card.Header>
                    <Row className="align-items-center mb-2">
                        <Col xs="12" md="5" xl={searchInFocus ? "6" : "2"}>
                            <FormControl
                                style={{ marginTop: "0px" }}
                                value={selectedName}
                                onFocus={() => setSearchInFocus(true)}
                                onBlur={() => setSearchInFocus(false)}
                                onChange={e => setSelectedName(e.target.value)}
                                placeholder="Suchen nach Anlagennummer bei Energielieferant, Adresse"
                                type="search"
                                className="rounded-pill" />
                        </Col>
                        <Col xs="6" md="3" xl="2" style={{display: "flex"}}>
                            <Form.Check
                                style={{ color: "#a2c13f", marginRight: 5 }}
                                type="switch"
                                id="leerstandSwitch"
                                label="Nur Leerstand"
                                checked={leerstand}
                                onChange={e => setLeerstand(e.target.checked)}
                            />
                            <EnergoTooltip tKey="3001" position="right" />
                        </Col>

                        <Col xs="6" md="3" xl="2" style={{display: "flex"}}>
                            <Form.Check
                                style={{ color: "#a2c13f", marginRight: 5 }}
                                type="switch"
                                id="deliverySwitch"
                                label="In Belieferung"
                                checked={delivery}
                                onChange={e => setDelivery(e.target.checked)}
                            />
                            <EnergoTooltip tKey="3002" position="right" />
                        </Col>

                        <Col xs="6" md="2" xl="1" className="text-center">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedEnergy === "" ? "Energieform" : selectedEnergy}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {energy?.map(e => (
                                        <li key={e} className="text-center">
                                            {selectedEnergy === e ?
                                                <a onClick={ev => { ev.preventDefault(); setSelectedEnergy("") }} href="/filter/energieform/reset" className="dropdown-item">
                                                    <Row>
                                                        <Col xs="1" style={{ paddingLeft: "7px" }}>
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        <Col xs="10">
                                                            {e}
                                                        </Col>
                                                    </Row>
                                                </a>
                                                :
                                                <a onClick={ev => { ev.preventDefault(); setSelectedEnergy(e) }} href={`/filter/energieform/${e}`} className="dropdown-item">
                                                    <Row>
                                                        <Col xs="1" style={{ paddingLeft: "7px" }}>
                                                            {e === "Strom" ? <SlEnergy /> :
                                                                e === "Gas" ? <TbFlame /> :
                                                                    e === "Oil" ? <MdOutlineOilBarrel /> :
                                                                        e === "Strom-Einspeisung" ? <MdOutlineSolarPower />
                                                                            : null
                                                            }
                                                        </Col>
                                                        <Col xs="10" className="text-start">
                                                            {e}
                                                        </Col>
                                                    </Row>
                                                </a>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        <Col xs="6" md="2" xl="1" className="text-center">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedYear === 0 ? "Jahr" : selectedYear}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {avaibleYears?.map(y => (
                                        <li key={y} className="text-center">
                                            {selectedYear === y ?
                                                <a onClick={e => { e.preventDefault(); setSelectedYear(0) }} href="/filter/Jahr/reset" className="dropdown-item">
                                                    <Row>
                                                        <Col xs="4">
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        <Col xs="8" className="text-start">
                                                            {y}
                                                        </Col>
                                                    </Row>
                                                </a>
                                                :
                                                <a onClick={e => { e.preventDefault(); setSelectedYear(y) }} href={`/filter/Jahr/${y}`} className="dropdown-item">
                                                    {y}
                                                </a>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        <Col xs="12" md="6" xl="4" className={`text-center ${searchInFocus? "mt-3":""}`}>
                            <p className="text-energo">{getDateRange()}</p>
                            <RangeSlider
                                value={monthRange} onInput={setMonthRange}
                                step={1}
                                min={1}
                                max={12}
                            />
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body style={{ padding: 0, paddingBottom: "1.5px" }}>
                    <ListGroup>
                        {currentView.length > 0 ? currentView.map(elv => (
                            <ElvListItem key={elv.id} elv={elv} anlage={anlagen.find(a => a.id === elv.x_anlage_id[0])} />
                        ))
                            : <ListGroup.Item>
                                <p>Wir haben keine Energielieferverträge gefunden.</p>
                            </ListGroup.Item>
                        }
                    </ListGroup>
                    <div className="text-center" style={{ marginTop: "43px" }} hidden={selectedElvs.length <= maxItemsInPagination}>
                        <EnergoPagination max={Math.ceil(selectedElvs.length / maxItemsInPagination)} current={currentPage} select={setCurrentPage} />
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default ElvTable;